import React from "react";
import './Waitlist.css';
import { useScrollBlock } from "../UseScrollBlock";
import Modal from "react-modal";
import { Helmet } from "react-helmet";
import Kol from '../../../utils/Kol';
import test from '../../../common/images/sera-dots.png';
import Config from "../../Config";

var showingJoin = false;
function WaitlistButton({onClick, checkQueryParam = false, showBg = true}) {
  const [showWaitlist, setShowWaitlist] = React.useState(false);
  const [blockScroll, allowScroll] = useScrollBlock();
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [errorFirstName, setErrorFirstName] = React.useState(false);
  const [errorLastName, setErrorLastName] = React.useState(false);
  const [errorEmail, setErrorEmail] = React.useState(false);

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  
  React.useEffect(() => {
    if (showWaitlist) {
      blockScroll();
    } else {
      allowScroll();
    }
  }, [showWaitlist, blockScroll, allowScroll])

  const onFirstNameChange = (e) => {
    if (e.target.value.length)
      setErrorFirstName(false);
    else
      setErrorFirstName(true);
    setFirstName(e.target.value)
  }

  const onLastNameChange = (e) => {
    if (e.target.value.length)
      setErrorLastName(false);
    else
      setErrorLastName(true);
    setLastName(e.target.value)
  }

  const onEmailChange = (e) => {
    if (e.target.value.length && isEmailValid(e.target.value))
      setErrorEmail(false);
    else
      setErrorEmail(true);
    setEmail(e.target.value)
  }

  const isEmailValid = (email) => {
    if (String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )) {
        return true;
      }
      return false;
  };

  const isSubmitDisabled = () => {
    return (firstName.length === 0 || lastName.length === 0 || !isEmailValid(email) || isSubmitting);
  }


  const closeModal = () => {
    allowScroll();
    setShowWaitlist(false);
  }

  const onButtonClicked = React.useCallback(() => {
    if (onClick) {
      onClick();
    }

    if (Kol.isSignedUp()) {
      window.location.href = Kol.getStatusURL();
      return;
    }
    blockScroll();
    setShowWaitlist(true);
  }, [blockScroll, onClick]);

  React.useEffect(() => {
    if (!checkQueryParam || showingJoin) {
      return;
    }

    showingJoin = true;
    const queryParams = new URLSearchParams(window.location.search);
    const action = queryParams.get('action');

    if (action === 'join') {
      onButtonClicked();
    }
  }, [checkQueryParam, onButtonClicked])


  return (
    <React.Fragment>
      <Helmet>
        <script src="https://b.kickoffpages.com/2.1.0/kol.js" id="koljs" data-campaign-id={Config.KOL_CAMPAIGN_ID} async />
      </Helmet>
      <button className={`main ${showBg ? '' : 'no-bg'}`} onClick={onButtonClicked}>Join the waitlist</button>
      <Modal
        isOpen={showWaitlist}
        onRequestClose={closeModal}
        contentLabel="My dialog"
        className="waitlist"
        overlayClassName="modal-background"
        closeTimeoutMS={1000}
      >
        <div className="waitlist-container">
          <div className='modal-close-btn'
              onClick={() => {
                allowScroll();
                setShowWaitlist(false);
              }}
          />
          <p className='title'>Join waitlist</p>
          <form onSubmit={() => setIsSubmitting(true)}>
            <div className='name-container'>
            <div className='field'>
              <div>
                <div className='field-label'>First name</div>
                <input id="firstName" type="text" name="firstName" placeholder="Enter first name" 
                  value={firstName} onChange={onFirstNameChange} onBlur={onFirstNameChange} />
                {errorFirstName && (
                  <div className="field-error">Please enter a valid first name</div>
                )}
              </div>
            </div>
            <div className='field'>
              <div>
                <div className='field-label'>Last name</div>
                <input id="lastName" type="text" name="lastName" placeholder="Enter last name"
                  value={lastName} onChange={onLastNameChange} onBlur={onLastNameChange} />
                {errorLastName && (
                  <div className="field-error">Please enter a valid last name</div>
                )}
              </div>   
            </div>  
            </div>       
            <div className='field'>
              <div>
                <div className='field-label'>Email</div>
                <input id="email" name="email" type="email" placeholder="Enter email" 
                  value={email} onChange={onEmailChange} onBlur={onEmailChange} />
                {errorEmail && (
                  <div className="field-error">Please enter a valid email</div>
                )}
              </div>
            </div>
            <div className='field'>
              <div>
                <div className='field-label'>Financial goals</div>
                <textarea id="goals" name="goals" placeholder="Tell us about your financial goals." />
              </div>
            </div>

            <p className='disclaimer'>We will never sell your personal information and will use it only to keep you updated about our launch.</p>
            
            <div className='processing-button-container'>
              <button className={`main ${isSubmitting ? 'processing' : ''}`} disabled={isSubmitDisabled()} type='submit'>
                Join the waitlist
              </button>
              <img src={test} className={`rotation ${isSubmitting ? 'show' : 'hide'}`} alt='' />
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default WaitlistButton;

